
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { useRef, useState } from 'react';

import { AddIcon, CancelIcon } from '../../../common/icons';
import { notifySuccess } from '../../../../services/notification';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { CREATE_POSITION_ADDRESS, GET_POSITION_ADDRESSES } from '../../../../graphql/contact-gql';
import AddressDetails, { AddressHandler } from '../../../org/contact-info/org-address/address-details';
import Button from '../../../common/button';

type AddressCreateProps = {
    positionId: number;
    isRole: boolean;
    isOpen: boolean;
    toggle: () => void;
}

const AddressCreate = (props: AddressCreateProps) => {
    const {positionId, isRole, isOpen, toggle} = props

    const [validated, setValidated] = useState<boolean>(false)
    const addressRef = useRef<AddressHandler>(null);
    const [createPositionAddress, {loading}] = useMutation(CREATE_POSITION_ADDRESS);
    const [typeaheadError, setTypeaheadError] = useState<string>("");

    const onCreateAddress = () => {
        if (addressRef.current && !addressRef.current.validate(true)) {
            setValidated(false)
            return
        }

        let addressInput = addressRef.current && addressRef.current.getAddress();

        createPositionAddress({
            variables: {
                positionId: positionId,
                address: addressInput,
            },
            refetchQueries: [{
                query: GET_POSITION_ADDRESSES,
                variables: { positionId: positionId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        });
    }

    const onChange = () => {
        setValidated(!!addressRef?.current && addressRef.current.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add a {isRole ? 'Role' : 'Position'} Address</ModalHeader>
            <ModalBody>
                <AddressDetails ref={addressRef} mandatory={true} onChange={onChange} onError={setTypeaheadError} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateAddress} disabled={!validated || !!typeaheadError}>
                    <AddIcon/> Add
                </Button>
                <Button color="secondary" onClick={toggle}>
                    <CancelIcon/> Cancel
                </Button>
            </ModalFooter>
        </Modal></>
    )
}

export default AddressCreate
